<!-- 阶段涨幅-单行数据 -->
<template>
  <div class="stage-rise-row">
    <div class="stage-rise-item left-date">{{item.date}}</div>
    <div class="stage-rise-item mid-rate" :style="{ color: getRateColor(item.rise)}"
      >{{item.rise}}</div>
    <div class="stage-rise-item mid-rate" :style="{ color: getRateColor(item.average)}"
      >{{item.average}}</div>
    <div class="stage-rise-item stage-rise-rank" @click="$goFundApp">
      <div class="row">
        <div>{{item.rank}}</div>
        <div :style="{ color:'#808080' }">{{`/${item.sc}`}}</div>
      </div>
      <div class="level">{{item.level}}</div>
    </div>
  </div>
</template>

<script>
import tool from '@/utils/tool';

export default {
  name: 'stage-rise-row',

  props: {
    item: { // 单行数据
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    getRateColor: tool.getRateColor,
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
}
.stage-rise-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
    font-size: 30px;
    color: #000000;
    line-height: 30px;
    padding: 20px 0 8px;
    .stage-rise-item {
      display: flex;
    }
    .left-date {
      flex: 2;
      justify-content: flex-start;
    }
    .mid-rate {
      flex: 3;
      justify-content: center;
      font-family: DINAlternate-Bold;
    }
    .stage-rise-rank {
      flex: 3;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      font-family: DINAlternate-Bold;
      .level {
        margin-top: 8px;
        font-size: 24px;
      }
    }
  }
</style>
